














































































































































































































































































































































































































































import SeletorDeLojasDoUsuario from '@/components/loja/SeletorDeLojasDoUsuario.vue'
import SeletorDeProdutos from '@/components/produto/SeletorDeProdutos.vue'
import Confirmacao from '@/components/ui/Confirmacao.vue'
import { ItemDaPreVenda, PreVenda } from '@/models/pre-venda/PreVenda'
import { dateTimeToPtBrFormat } from '@/shareds/date/date-utils'
import { converterProdutoParaProdutoSimples, obterQuantidadePesadaNaBalanca } from '@/shareds/produto-shareds'
import { maiorOuIgualAZero, obrigatorio } from '@/shareds/regras-de-form'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import { FindClienteUseCase, FindConfiguracaoDaContaUseCase, FindFornecedorUseCase, FindLojaUseCase, FindProdutoUseCase } from '@/usecases'
import { ItemPreVendaUseCase } from '@/usecases/venda/ItemPreVendaUseCase'
import { PreVendaUseCase } from '@/usecases/venda/PreVendaUseCase'
import axios, { CancelTokenSource } from 'axios'
import { Component, Ref, Vue, Watch } from 'vue-property-decorator'
import VueQuagga from "vue-quaggajs"
import { DataOptions } from 'vuetify'
import DialogoDeCsvItemDaPreVenda from './DialogoDeCsvItemDaPreVenda.vue'
import SeletorDeCliente from '../clientes/SeletorDeCliente.vue'
import { Cliente, FormCliente, Fornecedor } from '@/models'
import CampoDeItemDeVenda from '@/components/venda/CampoDeItemDeVenda.vue'
import SeletorDeUsuario from '@/components/usuario/SeletorDeUsuario.vue'
import SeletorDeFornecedorComBusca from '@/components/fornecedor/SeletorDeFornecedorComBusca.vue'
import DialogoDeEdicaoDeCliente from '@/components/cliente/DialogoDeEdicaoDeCliente.vue'
import { criarCliente } from '@/shareds/cliente-shareds'
import { imprimirPreVenda, imprimirEtiquetaDeVolumesPreVenda } from '@/shareds/venda-shareds'
import DialogoDeConferenciaPreVenda from './DialogoDeConferenciaPreVenda.vue'

Vue.use(VueQuagga);

@Component({
	components: {
		SeletorDeProdutos,
		Confirmacao,
		SeletorDeLojasDoUsuario,
		DialogoDeCsvItemDaPreVenda,
		SeletorDeCliente,
		CampoDeItemDeVenda,
		SeletorDeUsuario,
		SeletorDeFornecedorComBusca,
		DialogoDeEdicaoDeCliente,
		DialogoDeConferenciaPreVenda,
	},
})
export default class DialogoDeCadastroDaPreVenda extends Vue {
	@Ref() dialogoCsv!: DialogoDeCsvItemDaPreVenda
	@Ref() readonly campoDeBusca!: CampoDeItemDeVenda
	@Ref() dialogoEdicaoDeCliente!: DialogoDeEdicaoDeCliente
	@Ref() dialogoDeConferenciaPreVenda!: DialogoDeConferenciaPreVenda
	@Ref() campoQuantidadeAtacado!: any

	pesquisa = ''
	mostra = false
	loading = false
	carregando = false
	showCamera = false
	totalRegistros = -1
	buscandoProduto = false
	salvandoPreVenda = false
	editandoPreVenda = false
	lojaSelecionada: string | null = null
	carregandoItemNaPreVenda = false
	preVenda: PreVenda = criarPreVenda()
	itensDaPreVenda: ItemDaPreVenda[] = []
	itemDePreVenda: ItemDaPreVenda = criarItemPreVenda()
	valorLido: string | null = null
	cancelando: string[] = []
	cancelToken: CancelTokenSource | null = null
	mostrarDialogoObservacao = false
	mostrarDialogoSelecaoProduto = false
	mostrarDialogoLeituraDeCodigoBarras = false
	cliente: Cliente | null = null
	fornecedor: Fornecedor | null = null
	quantidadeNoAtacado = 1
	carregandoImpressao = false
	carregandoImpressaoEtiqueta = false
	itensDaPreVendaParaConferencia: ItemDaPreVenda[] = []
	painelItensAberto: number | null = null

	findClienteUseCase = new FindClienteUseCase()
	findFornecedorUseCase = new FindFornecedorUseCase()
	preVendaUseCase = new PreVendaUseCase()
	itemPreVendaUseCase = new ItemPreVendaUseCase()
	findProdutoUseCase = new FindProdutoUseCase()
	findConfiguracaoDaContaUseCase = new FindConfiguracaoDaContaUseCase()
	findLojaUseCase = new FindLojaUseCase()

	headers = [
		{ text: 'Produto', value: 'produto.nome' },
		{ text: 'Sku', value: 'produto.sku' },
		{ text: 'Ean', value: 'produto.eans' },
		{ text: 'Quantidade', value: 'quantidade' },
		{ text: 'Ações', value: 'actions', sortable: false, align: 'center' },
	]

	tiposDePreVenda = [
		{ text: 'Venda', value: 'venda' },
		{ text: 'Demonstração', value: 'demonstracao' },
		{ text: 'Consignação', value: 'consignacao' },
		{ text: 'Brinde', value: 'brinde' },
		{ text: 'Outras entradas', value: 'outras entradas' },
		{ text: 'Outras saídas', value: 'outras saidas' },
		{ text: 'Conserto', value: 'conserto' },
		{ text: 'Ativo', value: 'ativo' },
		{ text: 'Devolução entrada', value: 'devolucao entrada' },
		{ text: 'Devolução saída', value: 'devolucao saida' },
		{ text: 'Atacado', value: 'atacado'},
	]

	readerSize = {
		width: 860,
		height: 480,
	}

	paginacao: DataOptions = {
		page: 1,
		itemsPerPage: 5,
		sortBy: [],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}

	obrigatorio = obrigatorio
	maiorOuIgualAZero = maiorOuIgualAZero
	dateTimeToPtBrFormat = dateTimeToPtBrFormat

	async mostrar(preVendaSelecionada?: PreVenda, editando?: boolean, copiandoVenda?: boolean) {
		this.preVenda = preVendaSelecionada || criarPreVenda()
		this.editandoPreVenda = editando || false

		if(copiandoVenda) {
			this.cliente = this.preVenda.cliente || null
			this.itensDaPreVenda = this.preVenda.itens
			this.lojaSelecionada = this.preVenda.loja?.id || null
			if(this.preVenda.cpfOuCnpjDoCliente && this.preVenda.tipoDePreVenda === 'devolucao saida') {
				const fornecedoresBuscados = await this.findFornecedorUseCase.find({busca: this.preVenda.cpfOuCnpjDoCliente})

				if (fornecedoresBuscados.content.length > 0) {
					this.fornecedor = fornecedoresBuscados.content[0]
				}
			}
		} else {
			if(this.preVenda.id || editando) {
				if(this.preVenda.cpfOuCnpjDoCliente && this.preVenda.tipoDePreVenda !== 'devolucao saida') {
					this.cliente = await this.findClienteUseCase.findClienteByCpfOuCnpj(this.preVenda.cpfOuCnpjDoCliente)
				}

				if(this.preVenda.cpfOuCnpjDoCliente && this.preVenda.tipoDePreVenda === 'devolucao saida') {
					const fornecedoresBuscados = await this.findFornecedorUseCase.find({busca: this.preVenda.cpfOuCnpjDoCliente})

					if (fornecedoresBuscados.content.length > 0) {
						this.fornecedor = fornecedoresBuscados.content[0]
					}
				}

				this.lojaSelecionada = this.preVenda.loja?.id || null
				this.buscarItensDaPreVenda()
			} else {
				this.salvarPreVenda()
			}
		}

		this.mostra = true
	}

	async concluir() {
		try {
			this.salvandoPreVenda = true
			await this.salvarPreVenda()
			this.salvandoPreVenda = false
		} catch(e) {
			this.salvandoPreVenda = false
			AlertModule.setError(e)
		}

		this.fechar()
		this.$emit('buscarPreVendas')
	}

	fechar() {
		this.mostra = false
		this.carregando = false
		this.totalRegistros = -1
		this.itensDaPreVenda = []
		this.lojaSelecionada = null
		this.cliente = null
		this.fornecedor = null
		this.buscandoProduto = false
		this.preVenda = criarPreVenda()
		this.mostrarDialogoObservacao = false
		this.mostrarDialogoSelecaoProduto = false
		this.mostrarDialogoSelecaoProduto = false
		this.mostrarDialogoLeituraDeCodigoBarras = false
		this.paginacao = {
			page: 1,
			itemsPerPage: 5,
			sortBy: [],
			sortDesc: [],
			groupBy: [],
			groupDesc: [],
			multiSort: false,
			mustSort: false,
		}
		this.quantidadeNoAtacado = 1
		this.itensDaPreVendaParaConferencia = []
	}

	async cancelar() {
		this.lojaSelecionada = null
		this.mostra = false
		this.carregando = false
		this.totalRegistros = -1
		this.itensDaPreVenda = []
		this.buscandoProduto = false
		this.mostrarDialogoObservacao = false
		this.mostrarDialogoSelecaoProduto = false
		this.mostrarDialogoSelecaoProduto = false
		this.mostrarDialogoLeituraDeCodigoBarras = false
		this.paginacao = {
			page: 1,
			itemsPerPage: 5,
			sortBy: [],
			sortDesc: [],
			groupBy: [],
			groupDesc: [],
			multiSort: false,
			mustSort: false,
		}
		this.quantidadeNoAtacado = 1
		this.itensDaPreVendaParaConferencia = []
		this.cliente = null
		this.preVenda = criarPreVenda()

		try {
			if(this.preVenda.id && !this.editandoPreVenda) {
				await this.preVendaUseCase.remover(this.preVenda.id)
			}
		} catch(e) {
			AlertModule.setError(e)
		}		
	}

	@Watch('paginacao')
	async buscarItensDaPreVenda() {
		if(!this.preVenda.id) return
		try {
			this.carregando = true
			this.cancelToken = axios.CancelToken.source()
			const params = {
				idPreVenda: this.preVenda.id || null,
				pesquisa: this.pesquisa,
				page: this.paginacao.page - 1,
				size: this.paginacao.itemsPerPage,
				sort: 'createdAt,desc',
			}

			const axiosConfig = {
				cancelToken: this.cancelToken.token,
			}

			const listaDeItensDaVenda = await this.itemPreVendaUseCase.findItensDaPreVenda(params, axiosConfig)
			this.itensDaPreVenda = listaDeItensDaVenda.content
			this.totalRegistros = listaDeItensDaVenda.totalElements
			this.carregando = false
		} catch(e) {
			this.carregando = false
			AlertModule.setError(e)
		}
	}

	@Watch('lojaSelecionada')
	onChangeLojaSelecionada(lojaAtual, lojaAnterior) {
		if (!lojaAnterior) {
			this.salvarPreVenda()
		}
	}

	async salvarPreVenda() {
		if(!this.lojaSelecionada) return

		this.salvandoPreVenda = true

		try {
			this.preVenda.loja = await this.findLojaUseCase.findLojaById(this.lojaSelecionada)
			const preVendaCriada = await this.preVendaUseCase.salvar(this.preVenda)
			this.preVenda = preVendaCriada
		} catch(e) {
			AlertModule.setError(e)
		} finally {
			this.salvandoPreVenda = false
		}
	}

	@Watch('cliente', { deep: true })
	setCpfOuCnpjDoClienteNaPreVenda() {
		if(this.cliente && this.cliente.cnpjOuCpf === this.preVenda.cpfOuCnpjDoCliente) return

		this.preVenda.cpfOuCnpjDoCliente = this.cliente 
			? this.cliente?.cnpjOuCpf 
			: null
	}

	@Watch('fornecedor', { deep: true })
	setCnpjDoFornecedorNaPreVenda() {
		if(this.fornecedor && this.fornecedor.cnpjOuCpf === this.preVenda.cpfOuCnpjDoCliente) return

		this.preVenda.cpfOuCnpjDoCliente = this.fornecedor 
			? this.fornecedor?.cnpjOuCpf 
			: null
	}

	async atualizarListaDeProdutos(item: ItemDaPreVenda) {
		this.carregandoItemNaPreVenda = true
		this.preVenda.itens = this.preVenda.itens ?? [];
		const existeItemNaLista = this.itensDaPreVenda.findIndex(itemLista =>
			itemLista.produto.id === item.produto.id,
		);

		try {
			if (this.totalRegistros >= 500 && existeItemNaLista === -1) {
				throw new Error('A solicitação excede o limite de 500 produtos')
			}

			if (!this.preVenda.id) {
				throw new Error('Pre venda não existe')
			}

			if (this.preVenda.tipoDePreVenda === 'atacado'){
				item.quantidade = this.quantidadeNoAtacado > 0 ? this.quantidadeNoAtacado : 1
			}
			
			item.quantidadeConferida = item.quantidadeConferida != null ? item.quantidadeConferida : 0

			await this.itemPreVendaUseCase.salvarOuAtualizarItemPreVenda(item, this.preVenda.id)
			this.mostrarDialogoSelecaoProduto = false
			this.carregandoItemNaPreVenda = false
			this.quantidadeNoAtacado = 1

			if (this.preVenda.tipoDePreVenda === 'atacado'){
				this.blurCampoDeItem()
				this.focarQuantidadeAtacado()
			}
		} catch (error: any) {
			AlertModule.setError(error);
			this.mostrarDialogoSelecaoProduto = false
			this.carregandoItemNaPreVenda = false
		} finally {
			this.buscarItensDaPreVenda();
			this.painelItensAberto = 0
		}
	}

	async removerItemDaPreVenda(idItem: string) {
		if(!idItem) return
		this.cancelando.push(idItem)
		try {
			await this.itemPreVendaUseCase.remover(idItem)
			this.cancelando = this.cancelando.filter(id => idItem !== id)
			this.buscarItensDaPreVenda()
		} catch(e) {
			AlertModule.setError(e)
		}
	}

	beep() {
		const audio = document.querySelector('audio')
		if(!audio) return 
		audio.play()
	}

	async logIt(data: any) {
		this.showCamera = false
		this.buscandoProduto = true
		this.beep()
		this.valorLido = data.codeResult.code

		if (this.valorLido) {
			try {
				const produto = await this.findProdutoUseCase.findProdutoPorIdentificador(this.valorLido)

				const configuracaoDeConta = await this.findConfiguracaoDaContaUseCase.find()

				let quantidadeDeItens: number

				if (produto.unidadeDeMedida !== 'KG' && produto.unidadeDeMedida !== 'MT') {
					if (this.preVenda.tipoDePreVenda === 'atacado') {
						const q = Number(this.quantidadeNoAtacado) || 1
						quantidadeDeItens = q > 0 ? q : 1
					} else {
						quantidadeDeItens = 1
					}
				} else {
					quantidadeDeItens = obterQuantidadePesadaNaBalanca(
						'',
						configuracaoDeConta?.medida || 6,
						configuracaoDeConta?.eans || 7,
						configuracaoDeConta?.casasNumericas || 4,
					)
				}

				const item: ItemDaPreVenda = {
					id: '',
					produto: converterProdutoParaProdutoSimples(produto),
					quantidade: quantidadeDeItens,
					preco: produto.preco || 0,
					chaveNotaOrigem: '',
					quantidadeConferida: 0,
				}

				this.atualizarListaDeProdutos(item)
			} catch (error: any) {
				AlertModule.setError(error)
			} finally {
				this.buscandoProduto = false
				this.showCamera = true
			}
		}
	}

	get usuario() {
		return UserLoginStore.usuario
	}

	mostrarDialogoDeCliente() {
		if (!this.preVenda) return
		const cliente: FormCliente = !this.preVenda.cliente
			? criarCliente()
			: JSON.parse(JSON.stringify(this.preVenda.cliente))

		const indiceDaLoja = cliente.lojas.findIndex(loja => loja.id === this.preVenda?.loja?.id)
		if (indiceDaLoja === -1 && this.preVenda.loja) {
			cliente.lojas.push(this.preVenda.loja)
		}
		
		cliente.cnpjOuCpf = !cliente.cnpjOuCpf && this.preVenda.cpfOuCnpjDoCliente ? this.preVenda.cpfOuCnpjDoCliente : cliente.cnpjOuCpf
		this.dialogoEdicaoDeCliente.mostrar(cliente, !cliente.id)
	}

	atualizarClienteDaPreVenda(cliente: Cliente) {
		this.cliente = cliente
	}

	async imprimirEtiquetaPreVenda() {
		if (!this.cliente) return
		this.carregandoImpressao = true

		try {
			await imprimirPreVenda(this.preVenda.identificador, this.cliente.cnpjOuCpf)
		} catch (error: any) {
			AlertModule.setError(error)
			this.carregandoImpressao = false
		} finally {
			this.carregandoImpressao = false
		}
	}

	async mostrarDialogoConferencia() {
		this.cancelToken = axios.CancelToken.source()
		const params = {
			idPreVenda: this.preVenda.id || null,
			pesquisa: this.pesquisa,
			page: this.paginacao.page - 1,
			size: 500,
			sort: 'createdAt,desc',
		}

		const axiosConfig = {
			cancelToken: this.cancelToken.token,
		}
		const itens = await this.itemPreVendaUseCase.findItensDaPreVenda(params, axiosConfig)
		this.itensDaPreVendaParaConferencia = itens.content
		
		this.dialogoDeConferenciaPreVenda.mostrar()
	}

	async finalizarConferencia(itens: ItemDaPreVenda[]){
		try {
			itens.forEach(async item => {
				if (!this.preVenda.id) return
				item.quantidade = 0
				await this.itemPreVendaUseCase.salvarOuAtualizarItemPreVenda(item, this.preVenda.id)
			})

			this.preVenda.situacao = 'Conferida'
		} catch (error: any){
			AlertModule.setError
		} finally {
			this.buscarItensDaPreVenda();
		}
	}

	async reabrirPreVendaConferida(){
		this.preVenda.situacao = 'Aberto'
	}

	async imprimirEtiquetaDeVolumesPreVenda(){
		if (!this.cliente) return
		if (!this.preVenda.dataHoraCriacao) return AlertModule.setError("Necessário data de criação da pré venda.")
		if (this.preVenda.volumes <= 0 || !this.preVenda.volumes) return AlertModule.setError("Necessário preencher a quantia de volumes.")
		this.carregandoImpressaoEtiqueta = true

		try {
			await imprimirEtiquetaDeVolumesPreVenda(this.preVenda.identificador, this.cliente.cnpjOuCpf, this.preVenda.dataHoraCriacao, this.preVenda.volumes)
		} catch (error: any) {
			AlertModule.setError(error)
			this.carregandoImpressaoEtiqueta = false
		} finally {
			this.carregandoImpressaoEtiqueta = false
		}
	}

	focarCampoDeItem() {
		if (!this.mostra) return
		const campo: any = this.campoDeBusca
		if (!campo) return

		this.$nextTick(() => {
			if (typeof campo.focus === 'function') {
				campo.focus()
				return
			}

			const input: HTMLInputElement | null =
      campo.$el?.querySelector('input') ?? null

			if (input) {
				input.focus()
      input.select?.()
			}
		})
	}

	focarQuantidadeAtacado() {
		if (!this.mostra) return
		const campo: any = this.campoQuantidadeAtacado
		if (!campo) return

		this.$nextTick(() => {
			if (typeof campo.focus === 'function') {
				campo.focus()
      campo.select?.()
      return
			}

			const input: HTMLInputElement | null =
      campo.$el?.querySelector('input') ?? null

			if (input) {
				input.focus()
      input.select?.()
			}
		})
	}

	blurCampoDeItem() {
		if (!this.mostra) return

		const campo: any = this.campoDeBusca
		if (!campo) return

		this.$nextTick(() => {
			// Se o componente tiver método blur()
			if (typeof campo.blur === 'function') {
				campo.blur()
				return
			}

			// Fallback: pega o input interno do Vuetify
			const input: HTMLInputElement | null =
      campo.$el?.querySelector('input') ?? null

			if (input) {
				input.blur()
			}
		})
	}

}

function criarPreVenda(): PreVenda {
	return {
		id: undefined,
		identificador: '',
		situacao: 'Aberto',
		dataHoraCriacao: null,
		itens: [],
		loja: null,
		cpfOuCnpjDoCliente: null,
		vendedor: null,
		tipoDePreVenda: 'venda',
		vendaIdOrigem: '',
		representante: null,
		percentualRepresentante: 0,
		volumes: 0,
	}
}

function criarItemPreVenda(): ItemDaPreVenda {
	return {
		id: '',
		produto: {	
			id: '',
			nome: '',
			tipo: 'Padrão',
			preco: 0,
			pesoLiquido: 0,
			pesoBruto: 0,
			descontoVarejo: 0,
			eans: [],
			sku: null,
			identificadores:[],
			nomeCompleto: '',
			produtoDesativado: false,
			isValePresente: false,
			urlImagens: null,
			skuPai: null,
			estacao: null,
			marca: null,
			categoria: null,
			genero: null,
			fornecedor: null,
		},
		quantidade: 0,
		preco: 0,
		chaveNotaOrigem: '',
		quantidadeConferida: 0,
	}
}
